module.exports = __webpack_public_path__ + "media/img/apple-icon-60x60-3a61cc1fdd3190e917eeafcf5f56eb2b.png";